import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { EyeIcon, EyeOffIcon } from 'assets/icon';

const TYPES = [
  'text',
  'email',
  'password',
  'number',
  'date',
  'time',
  'month',
  'tel',
];

const Input = ({
  type = 'text',
  variant = 'custom',
  className,
  fullWidth = true,
  error,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword && showPassword ? 'text' : type;

  const toggle = () => setShowPassword((prev) => !prev);

  const classes = clsx(
    `border rounded-[6px] text-[14px] sm:text-[16px] mx-[3px] px-[12px] py-[4px]
      ${variant === 'default' ? 'h-[36px] bg-legacy-inputBg border-transparent' : 'h-[44px] bg-legacy-white border-legacy-primary'}`,
    'placeholder:text-legacy-placeholder',
    'focus:outline-none focus:border-legacy-focus focus:ring-[3px] focus:ring-legacy-focus/50',
    'disabled:opacity-50 disabled:cursor-not-allowed',
    'selection:bg-legacy-primary selection:text-white',
    fullWidth && 'w-[calc(100%-8px)]',
    isPassword && 'pr-[40px] [&::-ms-reveal]:hidden [&::-ms-clear]:hidden',
    error &&
      '!border-legacy-errorInput focus:border-legacy-errorInput focus:ring-legacy-errorInput/20',
    className,
  );

  const iconClasses =
    'absolute right-[12px] top-1/2 -translate-y-1/2 cursor-pointer text-gray-500 hover:text-gray-700';

  return (
    <div className="relative mb-[8px]">
      <input
        data-testid={rest.id ?? 'input'}
        type={inputType}
        className={classes}
        {...rest}
      />
      {isPassword &&
        (showPassword ? (
          <EyeOffIcon
            data-testid="EyeOffIcon"
            onClick={toggle}
            onMouseDown={(e) => e.preventDefault()}
            className={iconClasses}
          />
        ) : (
          <EyeIcon
            data-testid="EyeIcon"
            onClick={toggle}
            onMouseDown={(e) => e.preventDefault()}
            className={iconClasses}
          />
        ))}
    </div>
  );
};

Input.propTypes = {
  type: PropTypes.oneOf(TYPES),
  variant: PropTypes.string,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  error: PropTypes.bool,
  name: PropTypes.string.isRequired,
};

export default Input;
